import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import me from '../assets/me.jpg'

const Footer = props => (
  <Wrapper>
    <div className="container info">
      <div className="brand">
        <Link activeClassName="active" exact to="/">
          shotsnapp
        </Link>
      </div>
      <ul>
        {/* <li>
          <Link to="/features" activeClassName="active">
            Features
          </Link>
        </li> */}
        <li>
          <Link to="/use-cases" activeClassName="active">
            Use cases
          </Link>
        </li>
        {/* <li>
          <Link to="/tutorials" activeClassName="active">
            Tutorials
          </Link>
        </li> */}
        <li>
          <Link to="/faq" activeClassName="active">
            FAQ
          </Link>
        </li>
        {/* <li>
          <Link to="/faq" activeClassName="active">
            Roadmap
          </Link>
        </li> */}
        <li>
          <a href="https://goo.gl/forms/VNy976VMZAHJdKSr1" target="_blank">
            Feedback
          </a>
        </li>
        <li>
          <a href="https://headwayapp.co/shotsnapp-changelog" target="_blank">
            What's new
          </a>
        </li>
      </ul>
      <div className="action" style={{ textAlign: 'right' }}>
        <a href="http://twitter.com/tryshotsnapp" target="_blank">
          Twitter
        </a>
      </div>
    </div>
    <div className="credits">
      <div className="container ">
        <p>
          shotsnapp is a product by a solo maker,{' '}
          <a href="http://twitter.com/gaddafirusli" target="_blank">
            @gaddafirusli
          </a>
          . Support the project by{' '}
          <a href="https://app.shotsnapp.com/upgrade" target="_blank">
            upgrading to PRO
          </a>{' '}
          or{' '}
          <a href="https://www.buymeacoffee.com/gaddafirusli" target="_blank">
            buy me a coffee
          </a>. With love from Malaysia 🇲🇾
        </p>
      </div>
    </div>
    <div className="badge">
      <a href="http://twitter.com/gaddafirusli" target="_blank">
        <img src={me} alt="me" />
        <span>by @gaddafirusli</span>
      </a>
    </div>
  </Wrapper>
)

export default Footer

const Wrapper = styled.div`
  font-size: 16px;
  background: #191a1e;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
    padding:
  }
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 600px) {
      flex-direction:column;
    }
  }
  .info {
    padding: 50px 0;
  }

  .brand {
    flex: 0.7;
    a {
      font-weight: bold;
      font-size: 20px;
      color: #eee;
    }
  }
  ul {
    display: flex;
    flex: 1.6;
    margin: 0;
    list-style: none;
    justify-content: center;
    @media (max-width: 600px) {
      margin: 30px auto ;
      flex-direction:column;
    }
    li {
      margin: 0 5px;
      display: flex;
      height: 40px;
      @media (max-width: 600px) {
      justify-content:center;
    }
      a {
        display: flex;
        margin: 0 10px;
        align-items: center;
        transition: all 0.2s linear;
        &.active,
        &:hover {
          transition: all 0.2s linear;
          color: #fff;
        }

      }
    }
  }
  a {
    text-decoration: none;
    font-size: 15px;
    color: #ccc;
    &:hover {
      color: #fff;
    }
  }
  .action {
    flex: 0.7;
    text-align: right;
  }

  }
  .credits {
    font-size: 14px;
    padding: 20px 0;
    color: #999;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    .container {
      justify-content: center;
      text-align: center;
    }
    a {
      font-size: inherit;
    }
  }
  .badge{
    position: fixed;
    z-index: 999;
    box-shadow: 0 0 10px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.04);
    bottom:0;
    right:0;
    background:#fff;
    border-radius: 4px 0 0;
    a {
      padding: 4px 8px;
      color:#333;
      font-size: 13px;
      display:flex;
      justify-content: center;
      align-items:center;
      &:hover {
        color: #004cd4;
      }
    }
    img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin: 0 6px 0 0;
    }

  }
`



// WEBPACK FOOTER //
// ./src/components/Footer.js